export default __webpack_public_path__ + "static/media/time_ot.95c4d4e2.svg";